import posthog from 'posthog-js'
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="post-hog"
export default class extends Controller {
  static values = {
    apiKey: String,
    identification: Object
  }

  connect() {
    console.log('PostHogController connected')

    posthog.init(this.apiKeyValue, {
      api_host: 'https://eu.posthog.com',
      defaults: '2025-11-30',
      custom_campaign_params: ["ref"],
      person_profiles: 'always',
      enable_recording_console_log: true,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
            password: true
        }
      }
    })

    if (Object.keys(this.identificationValue).length) {
      const { id, email, name } = this.identificationValue
      posthog.identify(id.toString(), { email, name })
    }

    // this.trackPageView = this.trackPageView.bind(this)
    // document.addEventListener('turbo:load', this.trackPageView)
  }

  disconnect() {
    console.log('PostHogController disconnected')
    // document.removeEventListener('turbo:load', this.trackPageView)
  }

  trackPageView() {
    console.log('PostHogController#trackPageView')
    posthog.capture('$pageview')
  }
}
